module.exports = __webpack_public_path__ + "img/twitter.8da8922f.svg";